import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFilter, faInfoCircle, faSearch, faTimes } from '@fortawesome/free-solid-svg-icons'

import React, { Fragment as F, useContext, useEffect, useRef, useState } from 'react'
import Modal from 'react-modal'
import Select from 'react-select'
import {
  useNavigate,
} from 'react-router'
import {
  Link,
  useParams,
} from "react-router-dom"
import { toast } from 'react-toastify'

import {
  SchedulesCtx,
} from '../schedules'
import {
  useApiRouter,
  appRouter,
  C,
  logg,
} from '$shared'

import {
  AppCtx,
} from '$src/App'
import {
  BanksCtx,
} from '$src/components/banks'
import {
  QueriesCtx,
} from '.'

library.add( faFilter, faInfoCircle, faSearch, faTimes )

/**
 * ListsModal
 * Where is this used?
**/
const ListsModal = (props) => {
  // logg(props, 'ListsModal')

  const apiRouter = useApiRouter()
  const navigate  = useNavigate()

  /* state */

  const [ title, setTitle ] = useState('Add to Existing List')
  const [ btnLabel, setBtnLabel ] = useState('Add')
  const [ selectedListId, setSelectedListId ] = useState(false)

  /* ctx */

  const {
    actionName, setActionName,
    setLoading,
  } = useContext(AppCtx)

  const {
    results,        setResults,
    resultsTitle,   setResultsTitle,
    selectedBanks,  setSelectedBanks,
  } = useContext(BanksCtx)
  // logg(useContext(BanksCtx), 'BanksCtx in ListsModal')

  const {
    list, setList,
    listName, setListName,
    listModalOpen,          setListModalOpen,
    listsModalOpen,         setListsModalOpen,
    myListsList, setMyListsList,
    queriesList, setQueriesList, refreshQueriesList,
  } = useContext(QueriesCtx)

  const {
    oneResultTitle, setOneResultTitle, defaultOneResultTitle,
  } = useContext(SchedulesCtx)

  /* effects */

  useEffect(() => {
    if (actionName === C.lists_actions.remove_from_existing) {
      setTitle('Remove from Existing')
      setBtnLabel('Remove')
    }
  }, [ actionName ])

  /* methods */

  /* add to new, add to existing or remove from existing */
  const commit = () => {
    setLoading(true)
    logg([ actionName, selectedListId ], 'these-zz1')
    logg(apiRouter.listActionPath({ action: actionName, id: selectedListId }), 'adding or removing')

    fetch(apiRouter.listActionPath({ action: actionName, id: selectedListId }), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        list: {
          items: Object.keys(selectedBanks),
        },
      }),
    }).then(r => r.json()).then(inns => {
      if (actionName === C.lists_actions.add_to_existing) {
        toast(`Successfully added to the list.`)
      }
      if (actionName === C.lists_actions.remove_from_existing) {
        toast(`Successfully removed from the list.`)
      }
      navigate('/')
      refreshQueriesList()
      setListsModalOpen(false)
      setListsModalOpen(false)
      setLoading(false)
      setOneResultTitle(defaultOneResultTitle)
      setResults([])
      setResultsTitle(null)
      setSelectedBanks({})
    })
  }


  return <Modal
    ariaHideApp={false}
    className="ListsModal BaseModal"
    isOpen={listsModalOpen}
    onRequestClose={() => setListsModalOpen(false)}
    overlayClassName="ModalOverlay"
  >
    <div className='header'>
      <h5 >{ title }</h5>
      <div className='right'>
        <Link to='/' style={{ color: '#666' }} ><div className='close' style={{ width: '30px' }} onClick={() => {
          setListsModalOpen(false) ;
        } }><FontAwesomeIcon icon="fa-solid fa-times"
          style={{ cursor: 'pointer' }}
        /></div></Link>
      </div>
    </div>

    <div className='container'>
      <div className='row mt-3'>
        <label>Name</label>
        <Select className='select2'
          classNamePrefix="rs2"
          // isSearchable={false}
          name="selectedListId"
          options={myListsList}
          onChange={(ev) => {
            setSelectedListId(ev.value)
            setList(ev)
          } }
          styles={C.select2Styles}
        />
      </div>
    </div>

    <div className='actions mt-3'>
      <div className='left'></div>
      <div className='right'>
        <div className='Btn btn-primary' onClick={commit} >{ btnLabel }</div>
      </div>
    </div>

  </Modal>

}
export default ListsModal
